import { Button } from "common/components/ui/Button";
import { DrawerBody, DrawerFooter } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

interface FooterProps {
  onAddPaymentMethod: () => void;
  onClose: () => void;
}

export default function Footer({ onAddPaymentMethod, onClose }: FooterProps) {
  const isDesktop = useTwBreakpoint("lg");

  if (isDesktop)
    return (
      <div className="flex flex-col gap-2 items-center mt-6 pb-5">
        <Button onClick={onAddPaymentMethod}>Add payment method</Button>

        <Button variant="link-black" onClick={onClose}>
          Skip for now
        </Button>

        <p className="text-xxs text-black-500 text-center w-[264px]">
          Add your payment method now to keep your access uninterrupted after
          your free trial
        </p>
      </div>
    );

  return (
    <>
      <DrawerBody>
        <p className="mt-4 text-xs text-black-500 text-center mb-20">
          Add your payment method now to keep your access uninterrupted after
          your free trial
        </p>
      </DrawerBody>

      <DrawerFooter className="justify-between">
        <Button variant="link-black" onClick={onClose}>
          Skip for now
        </Button>

        <Button onClick={onAddPaymentMethod}>Add payment method</Button>
      </DrawerFooter>
    </>
  );
}
